import { useMemo } from 'react';
import classNames from 'classnames';

import { TitleV2 } from '../titlev2/titlev2.component';
import { Text } from '../text/text.component';
import { EditablePlaceholder } from '../editable-placeholder/editable-placeholder.component';
import { addSuperScript } from '../../utils/strings';

import {
  SIMPLE_STAT_EMPTY_LABEL,
  SimpleStatIsEmpty,
  SimpleStatProps,
  SimpleStatStyleClass,
} from './simple-stat.config';

const SimpleStat = ({
  disclaimerCharacter,
  statNumber,
  statDescription,
  statDisclaimer,
  appliedCssClassNames,
  configurationStatus,
  additionalClasses,
  propertiesId,
  propertiesLabel,
  propertiesRole,
  ...props
}: SimpleStatProps) => {
  const isLeftAligned = useMemo(
    () => !!appliedCssClassNames?.includes(SimpleStatStyleClass.ALIGN_LEFT),
    [appliedCssClassNames]
  );
  const isRightAligned = useMemo(
    () => !!appliedCssClassNames?.includes(SimpleStatStyleClass.ALIGN_RIGHT),
    [appliedCssClassNames]
  );
  const isSideBySideLayout = useMemo(
    () => !!appliedCssClassNames?.includes(SimpleStatStyleClass.LAYOUT_SIDE_BY_SIDE),
    [appliedCssClassNames]
  );

  const disclaimerText = statDisclaimer?.text;
  const descriptionText = statDescription?.text;

  const disclaimerRichText = addSuperScript(disclaimerText, disclaimerCharacter, false);
  const descriptionRichText = descriptionText && addSuperScript(descriptionText, disclaimerCharacter, true);

  return !SimpleStatIsEmpty({ ...props, statNumber, statDescription, statDisclaimer, configurationStatus }) ? (
    <div
      id={propertiesId}
      aria-label={propertiesLabel}
      role={propertiesRole}
      data-testid="snowflake-simple-stat"
      className={classNames('snowflake-simple-stat', additionalClasses, {
        'snowflake-simple-stat-align-left': isLeftAligned,
        'snowflake-simple-stat-align-right': isRightAligned,
      })}
    >
      <div
        className={classNames('snowflake-simple-stat-content', {
          'snowflake-simple-stat-content-layout-side-by-side': isSideBySideLayout,
        })}
      >
        {statNumber && <TitleV2 {...statNumber} />}
        {statDescription && <Text {...statDescription} text={descriptionRichText} />}
      </div>
      <div className="snowflake-simple-stat-disclaimer">
        {statDisclaimer && <Text {...statDisclaimer} text={disclaimerRichText} />}
      </div>
    </div>
  ) : (
    <EditablePlaceholder text={configurationStatus?.message || SIMPLE_STAT_EMPTY_LABEL} />
  );
};

export default SimpleStat;
